import styled from 'styled-components';

import {
  blackSphera,
  whiteSphera,
  greenSp,
  brandBlack,
  grayMediumSphera,
  brandYellowgreen
} from 'src/utilities/UIStyles/variables/Colors';

import { fadeIn, fadeOut } from 'src/utilities/animations';

export const CreateBeneficiaryModal = styled.section`
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  visibility: ${(props) => (props.showModalCreateBeneficiary ? 'visible' : 'hidden')};
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: rgb(0, 0, 0, 0.6);
  animation: ${(props) => (props.showModalCreateBeneficiary ? fadeIn : fadeOut)} 0.5s linear;
  @media (min-width: 600px) and (max-width: 1024px) {
  }

  @media (max-width: 600px) {
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 60%;
  max-width: 800px;
  border-radius: 5px;
  background-color: ${whiteSphera};
  padding: 3%;
  > h2 {
    font-size: 2.5vw;
    text-align: center;
    color: ${brandBlack};
    > span {
      color: ${greenSp};
      font-size: 2.5vw;
    }
  }
  @media (max-width: 600px) {
    width: 80%;
    > h2 {
      font-size: 6vw;
      text-align: center;
      > span {
        color: ${greenSp};
        font-size: 6vw;
      }
    }
  }
`;

export const InfoContainer = styled.section`
  margin: 2% 0;
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
`;

export const MainInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  margin: 5% 0;
  > div {
    width: 45%;
    h3 {
      font-size: 1.5vw;
      color: ${grayMediumSphera};
      margin-bottom: 5px;
      text-align: center;
      font-weight: 100;
    }
    > input {
      font-size: 1.5vw;
      width: 100%;
    }
    > select {
      width: 100%;
      font-size: 1.4vw;
    }
  }
  @media (max-width: 600px) {
    > div {
      width: 90%;
      h3 {
        font-size: 3vw;
      }
      input {
        font-size: 3vw;
      }
      select {
        font-size: 3vw;
      }
    }
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
`;

export const ConfirmButton = styled.button`
  color: ${brandBlack};
  font-size: 1.4vw;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
  width: 40%;
  margin: 5% 0;
  padding: 1%;
  border: none;
  border-radius: 5px;
  background-color: ${brandYellowgreen};
  cursor: pointer;
  transition: all 0.5s;
  &:hover {
    transform: scale(1.1);
  }
  @media (max-width: 600px) {
    font-size: 3vw;
  }
`;

export const CloseButton = styled.button`
  color: ${whiteSphera};
  font-size: 1.4vw;
  font-weight: bold;
  text-align: center;
  text-decoration: none;
  width: 40%;
  margin: 5% 0;
  padding: 1%;
  border: none;
  border-radius: 5px;
  background-color: ${brandBlack};
  cursor: pointer;
  transition: all 0.5s;
  &:hover {
    transform: scale(1.1);
  }
  @media (max-width: 600px) {
    font-size: 3vw;
  }
`;
